import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query'

import { listHodSites, type HodSitesParams } from '../api/hodSitesApi'

// One queryOptions factory per (params tuple) — shared cache between the
// dashboard's Site Score leaderboard and the /hod/departments grid. Both
// surfaces should request the SAME default tuple (no params at all) so
// they hit the same cache entry. 60s staleTime — sites + their issue
// counts don't change second-by-second, and the inbox mutations
// invalidate this key when they need to.
export const hodSitesQueryOptions = (params: HodSitesParams = {}) =>
  queryOptions({
    queryKey: ['hod-sites', params] as const,
    queryFn: () => listHodSites(params),
    staleTime: 60 * 1000,
    placeholderData: keepPreviousData,
  })

export function useHodSites(params: HodSitesParams = {}) {
  return useQuery(hodSitesQueryOptions(params))
}
